import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const MyAvatarCard = ({
  backGround,
  setSession,
  number,
  title,
  date,
  chatData,
  index,
  heading,
  handleDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(null);

  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const toggleDropdown = () => setDropdownVisible(!isDropdownVisible);

  const popupRef = useRef();

  const handleCheckboxChange = (sessionId, checked) => {
    if (checked) {
      setSession((prev) => [...prev, sessionId]);
    } else {
      setSession((prev) => prev.filter((id) => id !== sessionId));
    }
  };

  const togglePopup = (index) => {
    setClickedIndex(index);
    setIsOpen(!isOpen);
  };

  const toggleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        toggleClose();
        toggleDropdown();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const generateExcel = (xlsx) => {
    const link = document.createElement("a");
    link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${xlsx}`;
    link.download = "templated_output.xlsx";
    link.click();
  };

  const downloadFile = (filename, content, mimeType) => {
    const link = document.createElement("a");
    link.href = `data:${mimeType};base64,${content}`;
    link.download = filename;
    link.click();
  };

  const navigate = useNavigate();
  return (
    <div className="min-w-full  w-fit bg-white shadow-md rounded-md border border-[#00000026]  hover:bg-gray-100 cursor-pointer">
      <div className="p-4 flex max-xl:h-full items-center  justify-start gap-4">
        <div className="flex items-center justify-start gap-4 w-[25%]">
          {chatData?.email && (
            <div>
              <input
                type="checkbox"
                className="w-4 h-4 mt-1"
                onChange={(e) =>
                  handleCheckboxChange(chatData.session_id, e.target.checked)
                }
              />
            </div>
          )}
          <div 
           className="flex gap-2 items-center justify-center"
           onClick={() =>
            navigate("/sequential-startup/test-template-avatare", {
              state: {
                heading: heading,
                title: title,
                index: index,
                data: chatData,
                page: "history",
                show: false,
              },
            })
          }
          >
          <div
            style={{ background: backGround }}
            className="text-base flex justify-center items-center font-bold min-w-[38px] min-h-[38px] text-white rounded-full"
           
          >
            {number}
          </div>
            <div className="text-black font-medium text-base text-wrap">{title}</div>
            </div>
        
        </div>
         {chatData?.email ? 
          <div className="flex items-center justify-start  gap-2 w-[20%]">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="16"
                viewBox="0 0 18 16"
                fill="none"
              >
                <mask id="path-1-inside-1_3690_10157" fill="white">
                  <path d="M0.473684 1.36822V0.894531C0.348055 0.894531 0.227572 0.944437 0.138739 1.03327C0.049906 1.1221 0 1.24259 0 1.36822H0.473684ZM17.5263 1.36822H18C18 1.24259 17.9501 1.1221 17.8613 1.03327C17.7724 0.944437 17.6519 0.894531 17.5263 0.894531V1.36822ZM0.473684 1.8419H17.5263V0.894531H0.473684V1.8419ZM17.0526 1.36822V12.7366H18V1.36822H17.0526ZM15.6316 14.1577H2.36842V15.1051H15.6316V14.1577ZM0.947368 12.7366V1.36822H0V12.7366H0.947368ZM2.36842 14.1577C1.99153 14.1577 1.63008 14.008 1.36359 13.7415C1.09709 13.475 0.947368 13.1135 0.947368 12.7366H0C0 13.3648 0.249529 13.9672 0.693694 14.4114C1.13786 14.8555 1.74028 15.1051 2.36842 15.1051V14.1577ZM17.0526 12.7366C17.0526 13.1135 16.9029 13.475 16.6364 13.7415C16.3699 14.008 16.0085 14.1577 15.6316 14.1577V15.1051C16.2597 15.1051 16.8621 14.8555 17.3063 14.4114C17.7505 13.9672 18 13.3648 18 12.7366H17.0526Z" />
                </mask>
                <path
                  d="M0.473684 1.36822V0.894531C0.348055 0.894531 0.227572 0.944437 0.138739 1.03327C0.049906 1.1221 0 1.24259 0 1.36822H0.473684ZM17.5263 1.36822H18C18 1.24259 17.9501 1.1221 17.8613 1.03327C17.7724 0.944437 17.6519 0.894531 17.5263 0.894531V1.36822ZM0.473684 1.8419H17.5263V0.894531H0.473684V1.8419ZM17.0526 1.36822V12.7366H18V1.36822H17.0526ZM15.6316 14.1577H2.36842V15.1051H15.6316V14.1577ZM0.947368 12.7366V1.36822H0V12.7366H0.947368ZM2.36842 14.1577C1.99153 14.1577 1.63008 14.008 1.36359 13.7415C1.09709 13.475 0.947368 13.1135 0.947368 12.7366H0C0 13.3648 0.249529 13.9672 0.693694 14.4114C1.13786 14.8555 1.74028 15.1051 2.36842 15.1051V14.1577ZM17.0526 12.7366C17.0526 13.1135 16.9029 13.475 16.6364 13.7415C16.3699 14.008 16.0085 14.1577 15.6316 14.1577V15.1051C16.2597 15.1051 16.8621 14.8555 17.3063 14.4114C17.7505 13.9672 18 13.3648 18 12.7366H17.0526Z"
                  fill="white"
                />
                <path
                  d="M17.0526 13.4866H18V11.9866H17.0526V13.4866ZM1.61842 14.1577V15.1051H3.11842V14.1577H1.61842ZM16.3816 15.1051V14.1577H14.8816V15.1051H16.3816ZM0 13.4866H0.947368V11.9866H0V13.4866ZM0.473684 1.36822V2.86822H1.97368V1.36822H0.473684ZM17.5263 1.36822H16.0263V2.86822H17.5263V1.36822ZM0.473684 1.8419H-1.02632V3.3419H0.473684V1.8419ZM17.5263 1.8419V3.3419H19.0263V1.8419H17.5263ZM17.0526 1.36822V-0.131785H15.5526V1.36822H17.0526ZM15.6316 15.1051V16.6051V15.1051ZM0.947368 1.36822H2.44737V-0.131785H0.947368V1.36822ZM1.97368 1.36822V0.894531H-1.02632V1.36822H1.97368ZM0.473684 -0.605469C-0.0497704 -0.605469 -0.551784 -0.397527 -0.921921 -0.0273899L1.1994 2.09393C1.00693 2.2864 0.745881 2.39453 0.473684 2.39453V-0.605469ZM-0.921921 -0.0273899C-1.29206 0.342747 -1.5 0.844761 -1.5 1.36822H1.5C1.5 1.64041 1.39187 1.90146 1.1994 2.09393L-0.921921 -0.0273899ZM0 2.86822H0.473684V-0.131785H0V2.86822ZM17.5263 2.86822H18V-0.131785H17.5263V2.86822ZM19.5 1.36822C19.5 0.844764 19.2921 0.342749 18.9219 -0.0273899L16.8006 2.09393C16.6081 1.90146 16.5 1.64041 16.5 1.36822H19.5ZM18.9219 -0.0273899C18.5518 -0.397528 18.0498 -0.605469 17.5263 -0.605469V2.39453C17.2541 2.39453 16.9931 2.2864 16.8006 2.09393L18.9219 -0.0273899ZM16.0263 0.894531V1.36822H19.0263V0.894531H16.0263ZM0.473684 3.3419H17.5263V0.3419H0.473684V3.3419ZM19.0263 1.8419V0.894531H16.0263V1.8419H19.0263ZM17.5263 -0.605469H0.473684V2.39453H17.5263V-0.605469ZM-1.02632 0.894531V1.8419H1.97368V0.894531H-1.02632ZM15.5526 1.36822V12.7366H18.5526V1.36822H15.5526ZM19.5 12.7366V1.36822H16.5V12.7366H19.5ZM18 -0.131785H17.0526V2.86822H18V-0.131785ZM15.6316 12.6577H2.36842V15.6577H15.6316V12.6577ZM2.36842 16.6051H15.6316V13.6051H2.36842V16.6051ZM2.44737 12.7366V1.36822H-0.552632V12.7366H2.44737ZM0.947368 -0.131785H0V2.86822H0.947368V-0.131785ZM-1.5 1.36822V12.7366H1.5V1.36822H-1.5ZM2.36842 12.6577C2.38936 12.6577 2.40944 12.666 2.42425 12.6808L0.302925 14.8021C0.850727 15.3499 1.59371 15.6577 2.36842 15.6577V12.6577ZM2.42425 12.6808C2.43905 12.6956 2.44737 12.7157 2.44737 12.7366H-0.552632C-0.552632 13.5113 -0.244878 14.2543 0.302925 14.8021L2.42425 12.6808ZM-1.5 12.7366C-1.5 13.7626 -1.09244 14.7466 -0.366966 15.472L1.75435 13.3507C1.59149 13.1878 1.5 12.967 1.5 12.7366H-1.5ZM-0.366966 15.472C0.358504 16.1975 1.34245 16.6051 2.36842 16.6051V13.6051C2.1381 13.6051 1.91722 13.5136 1.75435 13.3507L-0.366966 15.472ZM15.5526 12.7366C15.5526 12.7157 15.561 12.6956 15.5758 12.6808L17.6971 14.8021C18.2449 14.2543 18.5526 13.5114 18.5526 12.7366H15.5526ZM15.5758 12.6808C15.5906 12.666 15.6106 12.6577 15.6316 12.6577V15.6577C16.4063 15.6577 17.1493 15.3499 17.6971 14.8021L15.5758 12.6808ZM15.6316 16.6051C16.6575 16.6051 17.6415 16.1975 18.367 15.472L16.2456 13.3507C16.0828 13.5136 15.8619 13.6051 15.6316 13.6051V16.6051ZM18.367 15.472C19.0924 14.7466 19.5 13.7626 19.5 12.7366H16.5C16.5 12.967 16.4085 13.1878 16.2456 13.3507L18.367 15.472Z"
                  fill="#7FB04F"
                  mask="url(#path-1-inside-1_3690_10157)"
                />
                <path
                  d="M1 2L9 10L17 2"
                  stroke="#7FB04F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {chatData?.email?.length > 30 ? `${chatData.email.slice(0, 24)}...` : chatData?.email}
          </div>:
           <div className="flex items-center gap-2  w-[20%]">
          
         </div>
        }
      
        <div className="text-sm font-medium w-[5%] ml-[2%] min-w-[100px]">{date.split("T")[0]}</div>
        <button
          style={{
            background: chatData.is_last
              ? "linear-gradient(90deg, #7FB04F 0%, #497964 100%)"
              : "linear-gradient(90deg, #6CA6C4 0%, #20556E 100%)",
          }}
          className="rounded-[16px] px-2  text-white"
        >
          {chatData.is_last ? "completed" : "Incomplete"}
        </button>
       

        {chatData.is_last ? (
          <div className="flex items-center justify-end w-[20%] gap-6 ml-[4%] mr-[7%]">
            {chatData?.response?.pdf && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(
                    "Summary.pdf",
                    chatData?.response?.pdf,
                    "application/pdf"
                  );
                  setDropdownVisible(false);
                }}
                className=" hover:bg-gray-100 cursor-pointer"
              >
                <img src="/pdf-icon.svg" width={25} alt="PDF icon" />
              </div>
            )}

            {chatData?.response?.docx && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(
                    "Summary.docx",
                    chatData?.response?.docx,
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  );
                }}
                className=" hover:bg-gray-100 cursor-pointer"
              >
                <img src="/doc-icon.svg" width={25} alt="DOC icon" />
              </div>
            )}

            {chatData?.response?.xlsx && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  generateExcel(chatData?.response?.xlsx);
                  setDropdownVisible(false);
                }}
                className=" hover:bg-gray-100 cursor-pointer"
              >
                <img src="/excel-icon.svg" width={25} alt="Excel icon" />
              </div>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-end w-[20%] gap-6 ml-[4%] mr-[7%]">
            <button
              onClick={() =>
                navigate("/sequential-startup/test-template-avatare", {
                  state: {
                    heading: heading,
                    title: title,
                    index: index,
                    data: chatData,
                    page: "history",
                    show: true,
                  },
                })
              }
              className="secondary px-3 py-2"
            >
              Resume Template
            </button>
          </div>
        )}

        <div
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(chatData.session_id);
          }}
          className="cursor-pointer justify-start items-center"
        >
          <img src="/delete.svg" className="w-5" />
        </div>
      </div>
    </div>
  );
};
